/**
 * @file App 入口
 * @author svon.me@gmail.com
 */

import "./style/style.scss";
import '../src/assets/css/main.css';
// 视频播放器样式
import 'xgplayer/dist/index.min.css';

import moment from "moment";
import config from "@/config";
import tool from '@/utils/tool';
import * as api from "@/api";
import {createPinia} from "pinia";
import {load} from "./locales/load";
import * as brower from "./utils/brower";
import recommend from "./utils/brower/recommend";
import {createApp} from "./bootstrap/main";

const Init = () => import("./bootstrap/init");

// 预检
const preCheck = function () {
  const status = brower.satisfies();
  if (!status) {
    recommend();
  }
  return status;
}

// 判断登录状态是否失效与是否登录
const permission = async function () {
  const token = tool.cookie.get(config.TOKEN_KEY);
  if (token) {
    try {
      let res = await api.system.dic.get.get("sys_project_priority");
      if (res && res.code && Number(res.code) === 200) {
        return true;
      } else if (res && res.scode && Number(res.scode) === 401) {
        const STANDBY = tool.cookie.get(config.TOKEN_STANDBY);
        if (STANDBY) {
          const query = {refresh_token: STANDBY};
          res = await api.auth.retoken.post(query);
          if (res && res.status && Number(res.scode) === 200) {
            const user = res.data || {};
            tool.cookie.set(config.TOKEN_KEY, user.token, {
              expires: moment().add(1, 'days').toDate(),
            });
            tool.cookie.set(config.TOKEN_STANDBY, user.refreshToken, {
              expires: moment().add(2, 'days').toDate(),
            });
            return true;
          }
        }
      }
    } catch (error) {
      // todo
      console.log(error);
    }
  }
  tool.cookie.remove(config.TOKEN_KEY);
  tool.cookie.remove(config.TOKEN_STANDBY);
}

const main = async function () {
  await permission();
  const pinia = createPinia();
  const {app, router} = await createApp();
  app.use(pinia);
  app.use(router);

  const [init] = await Promise.all([
    Init(),
    router.isReady()
  ]);
  app.use(init);
  app.mount('#app');
}


setTimeout(async function () {
  await load();
  const status = preCheck();
  if (status) {
    return main();
  }
});